import { B2bConfirm } from 'src/components/biz-b2b-confirm';

export default B2bConfirm;
